import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';
import { Page } from '../models/paging/page';
import { PagedData } from '../models/paging/paged-data';

@Injectable()
export class EngineerService {
    constructor(private http: HttpClient, private snotifyService: SnotifyService) {
    }

    public get(id: string = null): Promise<any> {
        return new Promise((resolve, reject) => {
          this.http.get<any>(environment.apiUrl + "engineer/GetById?id=" + id).subscribe(data => {
                resolve(data);
          }, error => {
            ////console.log(error);
            reject();
          });
        });
  }
  //this.filter.company_Id, this.filter.location_Id, this.filter.name, this.filter.email
  public getTable(page: Page, company_Id: number, location_Id: number, name: string, email: string): Promise<any> {
    const pagedData = new PagedData<any>();
    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'firstname'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '&name=' + name;

      this.http.get<any>(environment.apiUrl + "engineer/gettable?" 
        + "size=" + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder +
         params).subscribe(data => {
        page.totalElements = data.totalElements;
        page.totalPages = page.totalElements / page.size;

        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }
  public getEngineerCounts(): Promise<any> {
    return new Promise((resolve, reject) => {

      this.http.get<any>(environment.apiUrl + "engineer/GetEngineerCounts" ).subscribe(data => {
        resolve(data);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }


    public add(user): Promise<any> {
        return new Promise((resolve, reject) => {
            ////console.log(user);
            this.http.post<any>(environment.apiUrl + 'engineer/post', user).subscribe(data => {
                resolve(data);
                this.snotifyService.success('Successfully added web user');
            }, error => {
              ////console.log(error);
              this.snotifyService.error(error.error);
                reject();
            });
        });
    }

  public update(user): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post<any>(environment.apiUrl + 'engineer/post', user).subscribe(data => {
        resolve(data);
        this.snotifyService.success('Successfully added web user');
      }, error => {
        ////console.log(error);
        if (error.error.includes('license count'))
          this.snotifyService.error('You have exceeded your license count');
        else
        this.snotifyService.error(error.error);
        reject();
      });
    });
  }

    public delete(id): Promise<any> {
      return new Promise((resolve, reject) => {
          this.http.delete<any>(environment.apiUrl + 'engineer/delete?id=' + id).subscribe(data => {
              resolve(data);
            this.snotifyService.success('Successfully deleted engineer');
          }, error => {
              //console.log(error);
              reject();
          });
      });
  }

}
